import { defineMessages } from 'react-intl';

export default defineMessages({
  stable: { defaultMessage: 'Stable' },
  variable: { defaultMessage: 'Variable' },
  yes: { defaultMessage: 'Yes' },
  no: { defaultMessage: 'No' },
});
